import { MenuItem, TextField } from "@mui/material";
import { useTenant } from "../context/TenantContext";
import { getCampusList } from "../config/campuses";

/**
 * Compact dark-pill campus switcher that lives in the AppBar. Avoids the default white
 * outlined-input background so it doesn't break the navbar's dark surface.
 */
export default function CampusSwitcher({ size = "small" }) {
  const { campus, changeCampus } = useTenant();

  return (
    <TextField
      select
      size={size}
      value={campus}
      onChange={(e) => changeCampus(e.target.value)}
      variant="outlined"
      sx={{
        minWidth: 180,
        "& .MuiOutlinedInput-root": {
          color: "#fff",
          backgroundColor: "rgba(255,255,255,0.08)",
          borderRadius: 999,
          "& fieldset": { borderColor: "rgba(255,255,255,0.18)" },
          "&:hover fieldset": { borderColor: "rgba(255,255,255,0.35)" },
          "&.Mui-focused fieldset": { borderColor: "rgba(255,255,255,0.55)" },
        },
        "& .MuiSelect-select": {
          py: 0.75,
          fontWeight: 600,
          fontSize: 13,
        },
        "& .MuiSvgIcon-root": { color: "rgba(255,255,255,0.75)" },
      }}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            sx: { mt: 0.5, minWidth: 200 },
          },
        },
      }}
    >
      {getCampusList().map((c) => (
        <MenuItem key={c.slug} value={c.slug}>
          {c.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
